module.exports = new __parcel__URL__("logo.798b75d2.png").toString();